import { LocaleEnum } from '@systemeio/ui'

export const getFlutterwaveHelpPageLink = (locale?: LocaleEnum) => {
  switch (locale) {
    case LocaleEnum.DUTCH: {
      return 'https://help-nl.systeme.io/article/1861-hoe-integreer-je-flutterwave-met-systeme-io'
    }
    case LocaleEnum.DEUTSCH: {
      return 'https://help-de.systeme.io/article/1997-so-integrieren-sie-flutterwave-mit-systeme-io'
    }
    case LocaleEnum.PORTUGUESE: {
      return 'https://help-pt.systeme.io/article/2076-como-integrar-o-flutterwave-a-systeme-io'
    }
    case LocaleEnum.FRENCH: {
      return 'https://aide.systeme.io/article/1838-comment-integrer-flutterwave-a-systeme-io'
    }
    case LocaleEnum.JAPANESE: {
      return 'https://help-jp.systeme.io/article/2226-how-to-integrate-flutterwave-with-systeme-io'
    }
    case LocaleEnum.ARABIC: {
      return 'https://help-ar.systeme.io/article/2654-flutterwave-systeme-io-integration'
    }
    case LocaleEnum.SPANISH: {
      return 'https://help-es.systeme.io/article/1846-como-integrar-flutterwave-con-systeme-io'
    }
    case LocaleEnum.ITALIAN: {
      return 'https://help-it.systeme.io/article/1932-come-integrare-flutterwave-con-systeme-io'
    }
    default: {
      return 'https://help.systeme.io/article/1810-how-to-integrate-flutterwave-with-systeme-io'
    }
  }
}
